<template>
  <div>
    <page-header
      title="Create Function"
      breadcrumb="Dashboard >> Settings >> Organization Hierarchy >> Create Function"
    />
    <div class="new-function-form-wrapper card">
      <div class="new-function-form__details">
        <div>
          <p class="text-primary-yellow font-semibold pb-4">Function Details</p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 col-lg-6 col-12">
              <label for="fname" class="label">Function Name</label>
              <input
                type="text"
                class="input"
                id="fname"
                v-model="newFunction.name"
              />
            </div>
            <div class="col-md-6 col-lg-6 col-12">
              <label for="" class="label">Hierachy</label>
              <!-- <input type="text" class="input" /> -->
              <el-select v-model="newFunction.hierarchyId" placeholder="Select">
                <el-option
                  v-for="hierarchy in hierarchies"
                  :key="hierarchy.id"
                  :label="hierarchy.name"
                  :value="hierarchy.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md-6 col-lg-6 col-12">
              <label for="" class="label">Supervisory Function</label>
              <!-- <input type="text" class="input" /> -->
              <el-select v-model="newFunction.reportingTo" placeholder="Select">
                <el-option
                  v-for="supervisoryFunction in supervisoryFunctions"
                  :key="supervisoryFunction.id"
                  :label="supervisoryFunction.name"
                  :value="supervisoryFunction.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md-6 col-lg-6 col-12">
              <label for="" class="label">Cost Centre</label>
              <input
                type="text"
                class="input"
                v-model="newFunction.costCenter"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-between items-center">
        <h3 class="font-semibold">KPA Summary</h3>
        <primary-button buttonText="Import KPA" @click="importKPA = true" />
      </div>
      <div class="new-function-form__kpa-summary">
        <table class="custom-table responsive-table">
          <thead>
            <tr class="shadow-table rounded-lg">
              <th>KPA Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(kpi, index) in kpis"
              :key="kpi"
              class="shadow-table rounded-lg px-4"
            >
              <td class="w-full">
                <span v-if="editedKpiIndex == index" class="flex gap-2 items-center">
                  <input
                    type="text"
                    class="input kpi-input"
                    v-model="editedKpiValue"
                  />
                  <img src="@/assets/images/icons/save.svg" @click="updateKpi(index)" class="mb-3"  alt="save icon" />
                  <img src="@/assets/images/icons/icon-close.svg" @click="editedKpiIndex = null" class="mb-3" alt="close icon" />
                </span>
                <span v-else class=" flex gap-2">
                  {{ kpi }}
                  <span
                    v-if="editedKpiIndex == null"
                    @click="(editedKpiIndex = index), (editedKpiValue = kpi)"
                    class="flex gap-2"
                    >
                    <img src="@/assets/images/icons/edit.svg"  alt="Edit icon" /> Edit
                  </span>
                </span>
              </td>
              <td class="pr-4">
                <span 
                  class="font-semibold text-secondary-orange cursor-pointer flex gap-2 "
                  @click="deleteKpi(index)">
                    <img src="@/assets/images/icons/delete-icon.svg" class=" cursor-pointer" alt="delete icon" />
                     Delete
                </span>
              </td>
            </tr>
            <tr v-if="createKpi">
              <td class="w-full flex gap-2 items-center">
                <input type="text" class="input kpi-input" v-model="newKpi" />
                <span
                  class="cursor-pointer mb-3"
                  @click="saveKpi">
                    <img src="@/assets/images/icons/save.svg" alt="save icon" />
                </span>
                <img src="@/assets/images/icons/icon-close.svg" class="mb-3 cursor-pointer" @click="editedKpiIndex = null" alt="close icon" />
              </td>
              <td class="pr-4">
                <span
                  class="font-semibold text-secondary-orange cursor-pointer flex gap-2"
                  @click="(newKpi = ''), (createKpi = false)">
                    <img src="@/assets/images/icons/delete-icon.svg" alt="delete icon" />Delete
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="kpis.length < 1" class="flex flex-col gap-2 items-center">
          <empty-kpi-icon /> 
          <p>You haven’t created any KPIs yet</p>
          <p
            class="text-primary-yellow font-semibold cursor-pointer flex gap-2"
            @click="createKpi = true"
          >
            <img src="@/assets/images/icons/add.svg" alt="Add icon" />
            Add New KPA
          </p>
        </div>
          <p v-else
            class="text-primary-yellow font-semibold cursor-pointer flex gap-2"
            @click="createKpi = true"
          >
            <img src="@/assets/images/icons/add.svg" alt="Add icon" />
            Add New KPA
          </p>

      </div>
      <div class="button-wrapper">
        <button
          class="button"
          @click="$router.push({ name: 'OrganizationHierarchy' })"
        >
          Cancel
        </button>
        <primary-button buttonText="Create Function" @click="createFunction" :loading="creatingFunction" :disabled="disableButton"/>
      </div>
    </div>

    <import-KPA-modal
      v-if="importKPA"
      :showModal="importKPA"
      @import-kpis="importKPI"
      @close-modal="importKPA = false"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ImportKPAModal from "@/components/3pl/Settings/OrganizationHierachy/Function/Modals/ImportKPAModal";

export default {
    components:{
        PageHeader,
        ImportKPAModal 
    },
  data() {
    return {
      newFunction: {
        name: "",
        costCenter: "",
        hierarchyId: "",
        reportingTo: "",
      },
      importKPA: false,
      kpis: [],
      hierarchies: [],
      supervisoryFunctions: [{ name: "Nil", id: null }],
      createKpi: false,
      newKpi: "",
      editedKpiIndex: null,
      editedKpiValue: "",
      creatingFunction: false,
    };
  },
  computed: {
    disableButton() {
      let { name, costCenter, hierarchyId } = this.newFunction;
      if (
        name.length &&
        costCenter.length &&
        hierarchyId.length &&
        this.kpis.length
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.getAllHierarchies();
    this.getAllSupervisoryFunctions();
  },
  methods: {
    async createFunction() {
      this.creatingFunction = true;
      // Create Kpis object from kpis array
      this.createKpiObjects();
      try {
        let response = await this.$_createFunction(this.newFunction);
        console.log(response);
        this.onFunctionCreated();
      } catch (error) {
        this.handleError(error);
        this.creatingFunction = false;
      }
    },
    onFunctionCreated() {
      this.creatingFunction = false;
      this.getAllSupervisoryFunctions();
      this.resetInputValues();
      this.generateToast("Function successfully created!", "success");
      this.$emit("function-created");
      this.$router.push({ name: "OrganizationHierarchy" });
    },
    createKpiObjects() {
      let kpis = [];
      this.kpis.forEach((kpi) => {
        let kpiObject = {};
        kpiObject.name = kpi;
        kpis.push(kpiObject);
      });
      this.newFunction.kpis = kpis;
    },
    async getAllHierarchies() {
      try {
        let response = await this.$_getAllHierarchies();
        this.hierarchies = response.data.hierarchies;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllSupervisoryFunctions() {
      try {
        let response = await this.$_getAllFunctions();
        let functions = response.data.functions;
        // Need to re initialize function to avoid duplicating the contents
        this.supervisoryFunctions = [{ name: "Nil", id: null }];
        this.supervisoryFunctions = this.supervisoryFunctions.concat(functions);
        console.log(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    saveKpi() {
      this.kpis.push(this.newKpi);
      this.newKpi = "";
      this.createKpi = false;
      console.log(this.editedKpiIndex);
    },
    deleteKpi(index) {
      this.kpis.splice(index, 1);
    },
    updateKpi(index) {
      this.kpis[index] = this.editedKpiValue;
      this.editedKpiIndex = null;
    },
    resetInputValues() {
      this.newFunction = {
        name: "",
        costCenter: "",
        hierarchyId: "",
        supervisoryFunction: "",
      };
      this.kpis = [];
    },
    importKPI(evt){
      this.kpis = evt
    }
  },
};
</script>

<style lang="scss" scoped>
.kpi-input {
  width: 70%;
}

tr:first-child td:first-child {
  border-top-left-radius: 10px;
}
tr:first-child td:last-child {
  border-top-right-radius: 10px;
}
tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}
.table__search-input-wrapper {
  background: #7b858f10;
  width: 20vw;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }
  > div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>
